import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { useNavigate } from "react-router-dom";
// import jwt_decode from "jwt-decode";
// import Cookies from 'universal-cookie';
import { loginValidation } from "../../ApiCalls/LoginAuthenticateApi/api_v1_login_validate";
import styles from '../../styles/login/login.module.css';
import pubg from '../../images/v1/login/pubg.png'
import fortnite from '../../images/v1/login/fortnite.png'
import roblox from '../../images/v1/login/roblox.png'
import valorant from '../../images/v1/login/valorant.png'
import callofduty from '../../images/v1/login/callofduty.png'

const Login = () => {

    let navigate = useNavigate();
    const [showError, setShowError] = useState(false);
    const [erroMsg, setErrorMsg] = useState("Invalid Credentials");
    const [isDisabled, setIsDisabled] = useState(false);
    const usernameRef = useRef(null);
    const passwordRef = useRef(null);
    useLayoutEffect(() => {
        document.body.style.backgroundColor = "#f8b600";
        document.querySelector("meta[name='theme-color']").setAttribute("content", "#f8b600");
        document.title = "Login | Admin | CC ";
        return () => {
            document.body.style.backgroundColor = "rgb(199, 199, 199)";
            document.querySelector("meta[name='theme-color']").setAttribute("content", "rgb(199, 199, 199)");
        }
    }, []);
    useEffect(() => {
        sessionStorage.clear();
        localStorage.clear();
    }, []);

    const handleSubmit = (event) => {
        event.preventDefault();
        if (usernameRef.current.value === "" || passwordRef.current.value === "") {
            return;
        }
        setIsDisabled(true);
        setShowError(false);
        const username = usernameRef.current.value;
        const password = passwordRef.current.value;

        let formdata = {
            "username": username,
            "password": password
        }

        loginValidation(formdata).then((res) => {
            setIsDisabled(false);

            let data = res.data;
            if (res.status === 200 && data.message === "ok") {
                const accessToken = res.headers['access_token'];
                if (accessToken != null) {
                    sessionStorage.setItem('token', accessToken);
                }
                navigate("/home");
            } else {
                setErrorMsg(data.data.errDetail)
                setShowError(true);
            }
        }).catch((e) => {
            setIsDisabled(false);
            setErrorMsg("We can not process your request at this time please try later");
            setShowError(true);
        })

    }

    function handleChange() {
        if (showError === true) {
            setShowError(false);
        }
    }




    return (
        <>
            <main className={styles.main + ' d-flex justify-content-center flex-column align-items-center'}>
                {/* <section className={styles.banner_section}>
                    <img src="" alt="" />
                    <figure className={styles.banner}>

                    </figure>
                    <h1 className={styles.title}>ding</h1>
                </section> */}
                <section className={styles.subtitle}>
                    <h3 className={styles.subtitle_H}>learn, play &#x2130; win <br /> exciting rewards</h3>
                </section>
                <section className={styles.games_banner + ' d-flex flex-row justify-content-center w-300 mt-15'}>
                    <div>
                        <img src={pubg} alt="pubg" />
                    </div>
                    <div>
                        <img src={fortnite} alt="fortnite" />
                    </div>
                    <div>
                        <img src={roblox} alt="roblox" />
                    </div>
                    <div>
                        <img src={valorant} alt="valorant" />
                    </div>
                    <div>
                        <img src={callofduty} alt="call of duty" />
                    </div>
                </section>
                <section className={styles.formSection + ` d-flex justify-content-center flex-column align-items-center mt-30`}>
                    <p className={styles.loginFormTitle + ' mb-5i mt-4'}>Admin Login</p>
                    {showError && <p className={styles.pinMessage}>{erroMsg}</p>}
                    <form onSubmit={handleSubmit} className='text-center mt-3'>
                        <input type="text" className={styles.form_input} placeholder="Enter Username" name="phone" required="True" minLength="3" maxLength="11" id="field" autoComplete="off" ref={usernameRef} onChange={handleChange} onKeyDown={(e) => {
                            const allowedKeys = [
                                'Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete', 'Home', 'End'
                            ];

                            const isValidChar = /^[a-zA-Z0-9.-]$/.test(e.key);

                            if (!isValidChar && !allowedKeys.includes(e.key)) {
                                e.preventDefault();
                            }
                        }}></input>
                        <p className={styles.otpText + ' mt-15 mb-0'}>
                            <input type="password" className={styles.form_input} placeholder="Enter Password" name="phone" required="True" minLength="3" maxLength="11" id="field" autoComplete="off" ref={passwordRef} onChange={handleChange}></input>
                        </p>
                        <p className={styles.pinMessage} id="pinMessage"> </p>
                        <button className={styles.otpButton + '  btn mt-15 mb-15 '} id="btnsubmit" type='submit' disabled={isDisabled}>
                            LOGIN
                        </button>

                    </form>


                </section>

            </main>
        </>
    );
}

export default React.memo(Login);